/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ServiceObjectToDocumentV1Dto } from '../models/ServiceObjectToDocumentV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServiceObjectsDocumentsService {
  /**
   * @param uuid objectId
   * @param documentUuid documentUuid
   * @returns ServiceObjectToDocumentV1Dto create entity
   * @throws ApiError
   */
  public static serviceObjectDocumentControllerV1AssignDocumentV1(
    uuid: string,
    documentUuid: string,
  ): CancelablePromise<ServiceObjectToDocumentV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/service-objects/{uuid}/document/{documentUuid}',
      path: {
        uuid: uuid,
        documentUuid: documentUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid objectId
   * @param documentUuid documentUuid
   * @returns ServiceObjectToDocumentV1Dto the entity
   * @throws ApiError
   */
  public static serviceObjectDocumentControllerV1UnassignDocumentV1(
    uuid: string,
    documentUuid: string,
  ): CancelablePromise<ServiceObjectToDocumentV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/service-objects/{uuid}/document/{documentUuid}',
      path: {
        uuid: uuid,
        documentUuid: documentUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
}
